export const COLORS = {
  primary: "#2D6A4F",
  primaryLight: "#40916C",
  primaryLighter: "#52B788",
  accent: "#74C69D",
  accentLight: "#B7E4C7",
  accentLighter: "#D8F3DC",
  bg: "#F8FDF9",
  surface: "#FFFFFF",
  surfaceGreen: "#F0FAF4",
  text: "#1B3A2D",
  textMuted: "#5A7A6A",
  textLight: "#8BAA98",
  border: "#C8E6D4",
  warning: "#F4A261",
  warningLight: "#FEF3E2",
  success: "#52B788",
  successLight: "#E8F5E9",
  white: "#FFFFFF",
};

export const AVATARS = ["🦁","🐼","🦊","🐸","🦋","🐬","🦄","🐢","🦉","🐙","🐯","🦩"];

export const MOODS = [
  { emoji: "😄", label: "Amazing", color: "#FFD93D", value: 5 },
  { emoji: "🙂", label: "Good", color: "#6BCB77", value: 4 },
  { emoji: "😐", label: "Okay", color: "#74C69D", value: 3 },
  { emoji: "😔", label: "Not great", color: "#4D96FF", value: 2 },
  { emoji: "😢", label: "Sad", color: "#845EC2", value: 1 },
];

export const COPING_TOOLS = [
  { emoji: "🌬️", label: "Breathe", desc: "Take 3 deep breaths", color: "#4D96FF" },
  { emoji: "🎵", label: "Calm music", desc: "Listen to something peaceful", color: "#845EC2" },
  { emoji: "✍️", label: "Write it out", desc: "Put your feelings on paper", color: "#F4A261" },
  { emoji: "🚶", label: "Move your body", desc: "Walk, stretch, or dance", color: "#6BCB77" },
];

export const AFFIRMATIONS = [
  "You are doing amazing! 🌟",
  "Every day you grow stronger 💪",
  "You make your family proud 💚",
  "Small steps lead to big wins 🏆",
  "You are loved just as you are 💛",
  "Today is a great day to try! 🌈",
];

export const LIFE_SKILLS = {
  "Self-Care": [
    { name: "Brush teeth morning & night", points: 5, emoji: "🦷" },
    { name: "Get dressed independently", points: 10, emoji: "👕" },
    { name: "Shower or bath time", points: 5, emoji: "🚿" },
    { name: "Make bed", points: 10, emoji: "🛏️" },
    { name: "Pack school bag", points: 10, emoji: "🎒" },
  ],
  "Emotional Regulation": [
    { name: "Take a Break", points: 15, emoji: "🧘" },
    { name: "Name my feelings today", points: 10, emoji: "💭" },
    { name: "Practice deep breathing", points: 10, emoji: "🌬️" },
    { name: "Ask for help when frustrated", points: 15, emoji: "🤝" },
  ],
  "Helping at Home": [
    { name: "Set the table", points: 10, emoji: "🍽️" },
    { name: "Clear dishes after meal", points: 10, emoji: "🧹" },
    { name: "Take out trash", points: 15, emoji: "🗑️" },
    { name: "Water plants", points: 10, emoji: "🌱" },
    { name: "Feed pet", points: 10, emoji: "🐾" },
  ],
  "Social Skills": [
    { name: "Use kind words with siblings", points: 15, emoji: "💚" },
    { name: "Share without being asked", points: 20, emoji: "🤲" },
    { name: "Say please and thank you", points: 5, emoji: "🙏" },
  ],
  "Independence Skills": [
    { name: "Complete homework independently", points: 20, emoji: "📚" },
    { name: "Manage screen time", points: 15, emoji: "📱" },
    { name: "Prepare simple snack", points: 15, emoji: "🍎" },
  ],
};

export const REWARD_PRESETS = [
  { name: "Movie night", points: 50, emoji: "🎬" },
  { name: "30 min extra screen time", points: 30, emoji: "📱" },
  { name: "Choose dinner", points: 40, emoji: "🍕" },
  { name: "$5 allowance", points: 100, emoji: "💵" },
  { name: "Friend sleepover", points: 150, emoji: "🏠" },
  { name: "Outing of choice", points: 200, emoji: "🎉" },
];
